import { isToday, parse } from 'date-fns';
import {
	clearLoadedTable,
	getOrdersByTable,
	selectLoadedTable,
	setLoadedTable,
} from 'entities/orders';
import { useCallback, useEffect, useState } from 'react';
import { Table } from 'shared/lib/core';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';

export const useTableOrders = () => {
	const dispatch = useAppDispatch();
	const loadedTable = useAppSelector(selectLoadedTable);
	const [tableId, setTableId] = useState('');

	const loadTables = useCallback(
		(tableId: string) => {
			const date = document.getElementById('app-selected-date-value')?.getAttribute('data-value');

			if (date && !isToday(parse(date as string, 'yyyy-MM-dd', new Date(0)))) {

				dispatch(
					getOrdersByTable({
						resource: tableId,
						on_date: date,
						status: 'appointed'
					}),
				);

				return
			}

			dispatch(
				getOrdersByTable({
					resource: tableId,
				}),
			);
		},
		[dispatch],
	);

	const fetchTableOrders = useCallback(
		(table: Table) => {
			setTableId(table.id?.toString());

			loadTables(table.id?.toString());

			dispatch(setLoadedTable({ tableName: table.name }));
		},
		[dispatch, loadTables],
	);

	const clearTableOrders = useCallback(() => {
		dispatch(clearLoadedTable());
		setTableId('');
	}, [dispatch]);

  const clearTableId = useCallback(() => {
		dispatch(clearLoadedTable());
  }, [dispatch])

	useEffect(() => {
		if (!loadedTable) {
			setTableId('');
		}
	}, [loadedTable]);

	useEffect(() => {
		if (!tableId) {
			return;
		}

		const intervalId = setInterval(() => {
			loadTables(tableId);
		}, 30_000);

		return () => clearInterval(intervalId);
	}, [tableId, loadTables]);

	useEffect(() => {
		return clearTableOrders;
		//eslint-disable-next-line
	}, []);

	return { fetchTableOrders, clearTableOrders, loadedTable, clearTableId };
};
